export default __webpack_public_path__ + "static/media/CardImg3.6cd28245.jpg";